// "Claim your firm" links from admin outreach emails look like /signup/5?invite=<token>.
// The token is kept in the browser until the firm finishes its profile, so the
// claim step can pre-select the firm (server: /outreach/invite/:token).
const KEY = 'qcr.firmInvite';
const TOKEN_RX = /^[a-f0-9]{48}$/;

export function rememberFirmInvite(search = window.location.search) {
  try {
    const token = new URLSearchParams(search).get('invite');
    if (token && TOKEN_RX.test(token)) window.localStorage.setItem(KEY, token);
  } catch (e) { /* storage unavailable - the invite is just not pre-selected */ }
}

export function readFirmInvite() {
  try {
    const token = window.localStorage.getItem(KEY);
    return token && TOKEN_RX.test(token) ? token : null;
  } catch (e) { return null; }
}

export function clearFirmInvite() {
  try { window.localStorage.removeItem(KEY); } catch (e) { /* ignore */ }
}
